import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {formatDateTime} from "../../../utils/Formatter";
import {FullImagePreview} from "../../../components/FullImagePreview";

const CameraEventView = ({ imageUrl, numberPlateImageUrl}) => {

	const {t}  = useTranslation();
	const [imagePreview, setImagePreview] = useState(null);

    return (
        <>
        {imagePreview && <FullImagePreview src={imagePreview} onClick={e => setImagePreview(null)} />}
        <List className="condensedList">
           <ListItem>
              {numberPlateImageUrl && <img src={numberPlateImageUrl} />}
          </ListItem>
           <ListItem>
               <a href="#" onClick={e => setImagePreview(imageUrl)}><img src={imageUrl} className="compressedImg" /></a>
          </ListItem>
        </List>
       </>
    );
}

export default CameraEventView;